// extracted by mini-css-extract-plugin
export default {"portfolio":"PortfolioPage_portfolio__5ztjk","portfolioHeader":"PortfolioPage_portfolioHeader__VmI1S"};